<template>
    <div
        class="flex items-center gap-x-2 gap-y-1 empty:hidden"
        :class="singleLine ? 'flex-nowrap overflow-hidden' : 'flex-wrap'"
    >
        <!-- Rows wrap a long chip as before; only a card's single line truncates it, so there it names itself on hover. -->
        <MuvalTippy
            v-if="file.shared_with_field_staff"
            triggers="mouseenter"
            :disabled="!singleLine"
            :interactive="false"
            class="flex"
            :class="{ 'pointer-events-auto min-w-0': singleLine }"
            data-test="file-chip-shared"
        >
            <div
                class="card text-muval-gray-1 flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-xs"
                :class="{ 'min-w-0': singleLine }"
            >
                <span
                    class="bg-brand size-1.5 rounded-full"
                    :class="{ 'shrink-0': singleLine }"
                />
                <span :class="{ truncate: singleLine }">Shared with field staff</span>
            </div>
            <template #content>
                <span class="text-sm">Shared with field staff</span>
            </template>
        </MuvalTippy>
        <MuvalTippy
            v-for="tag in file.tags ?? []"
            :key="tag"
            triggers="mouseenter"
            :disabled="!singleLine"
            :interactive="false"
            class="flex"
            :class="{ 'pointer-events-auto min-w-0': singleLine }"
        >
            <div
                class="card text-muval-gray-1 flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-xs"
                :class="{ 'min-w-0': singleLine }"
            >
                <span
                    :style="{ backgroundColor: getColourFromText(tag) }"
                    class="size-1.5 rounded-full"
                    :class="{ 'shrink-0': singleLine }"
                />
                <span :class="{ truncate: singleLine }">{{ capitalize(tag) }}</span>
            </div>
            <template #content>
                <span class="text-sm">{{ capitalize(tag) }}</span>
            </template>
        </MuvalTippy>
        <slot />
    </div>
</template>

<script setup lang="ts">
import MuvalTippy from '@components/MuvalTippy.vue';
import { getColourFromText } from '@utilities/colors';

/** A stored file's sharing and tag chips, shared by its list row and its card. */

withDefaults(
    defineProps<{
        file: Record<string, any>;
        /** Keeps the chips to one line, truncating them, where a card has no room to wrap. */
        singleLine?: boolean;
    }>(),
    { singleLine: false },
);

const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);
</script>
